import { Heading, HStack, Image, Text, VStack, Box, Link} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const Card = ({ title, description, imageSrc, textAlign = "center", imageBorder, imageHref, imageHeight = "250px" }) => {
  // Implement the UI for the Card component according to the instructions.
  // You should be able to implement the component with the elements imported above.
  // Feel free to import other UI components from Chakra UI if you wish to.



    return <Box bg = "white" borderRadius={15} boxShadow="md"
      overflow="hidden" 
      _hover={{ boxShadow: "lg", transform: "scale(1.02)", transition: "all 0.3s ease-in-out" }}
      transition="all 0.3s ease-in-out" w="100%" maxW={{ base: "100%", md: "320px" }}
      >
          <VStack  maxHeight= "400px" justifyContent="space-between" alignItems="center">
            {imageHref ? (
              <Link href={imageHref}>
                <Image src = {imageSrc} borderRadius={15}  maxHeight={imageHeight} width="100%" border={imageBorder} cursor="pointer"/>
              </Link>
            ) : (
              <Image src = {imageSrc} borderRadius={15}  maxHeight={imageHeight} width="100%" border={imageBorder}/>
            )}
            <Heading marginBottom={-3} px={3} size= "md" color = "black" textAlign="center"> {title}</Heading>
            <Box width="100%" textAlign={textAlign}>
              <Text px={3} py={4} fontSize= "15px" color = "GrayText"> {description} </Text>
      
            </Box>
          </VStack>
        </Box>;
};

export default Card;
